/**
 * Finds a run's generated 3D model among its output assets.
 *
 * Like getInputImageAsset, the source is deliberately not part of the match: an
 * output model can be provider-generated ('ai_generated') or, for a run seeded from
 * an uploaded mesh, carry the upload's source. Only the asset type identifies it.
 *
 * @param {Array<Object>|undefined} assets - Run output assets
 * @returns {Object} The matching asset, or {} when there is no output model
 */
export const getOutputModelAsset = assets => (
  assets?.find(asset => asset.assetType === '3d_model') || {}
)
